import apiService from "./apiService";
import AppConstants from "../appConstants";

class TopicService {
    getAllTopic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_TOPIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getTopicDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_TOPIC}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerTopic(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_TOPIC, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteTopic(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_TOPIC}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_TOPIC_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new TopicService();
